import styles from '../style'
import { discount, Ai } from '../assets'
import GetStarted from './GetStarted'

const Hero = () => {
  return (
    <section id='home' className={`flex md:flex-row flex-col ${styles.paddingY}`}>
      <div className={`flex-1 ${styles.flexStart} flex-col xl:px-0 sm:px-16 px-6`}>

        <div className='flex flex-row justify-between items-center w-full'>
        <h1 className='flex-1 font-head font-semibold ss:text-[72px] text-[52px] text-white ss:leading-[100.8px] leading-[75px]'>
          Simplify Your <br className='sm:block hidden'/> {" "}
          <span className='text-gradient'>Project Workflow</span> {" "}
        </h1>
          <div className='ss:flex hidden md:mr-4 mr-0'>
            <GetStarted/>
          </div>
        </div>
        {/* <h1 className='font-poppins font-semibold ss:text-[68px] text-[52px] text-white ss:leading-[100px] leading-[75px] w-full'>
          Empower Your Future.
        </h1> */}
        <p className={`${styles.paragraph} max-w-[670px] mt-5`}>
          We offer innovative final year project solutions and internship opportunities aimed at preparing students for practical industry challenges. Our expert team ensures projects adhere to rigorous academic and professional standards.
        </p>
      </div>
      <div className={`flex-1 flex ${styles.flexCenter} md:my-0 my-10 relative`}>
        <img
          src={Ai}
          alt='billing'
          className='w-[100%] h-[100%] relative z-[5]'
        />
        <div className="absolute z-[0] w-[40%] h-[35%] top-0 pink__gradient" />
        <div className="absolute z-[1] w-[80%] h-[80%] rounded-full white__gradient bottom-40" />
        <div className="absolute z-[0] w-[50%] h-[50%] right-20 bottom-20 blue__gradient"/>
      </div>
      <button className={`ss:hidden ${styles.flexCenter}`}>
        <GetStarted/>
      </button>
    </section>
  )
}

export default Hero
